<template>
  <div class="home">
    <TableList
      :table-data="tableData"
      :label-data="tableLabel"
      :loading="loading"
      :page="currentPage"
      :page-total="pageTotal"
      @changePage="handleCurrentChange"
    >
      <template v-slot:btns>
        <el-button type="primary" plain round @click="addAccount">
          <i class="el-icon-plus el-icon--left" />
          添加
        </el-button>
      </template>
      <template v-slot:active="{ scope }">
        <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
        <!-- <el-link
          type="danger"
          :underline="false"
          class="ml-10"
          style="vertical-align: initial"
          @click="deleteRow(scope.row.id, tableData)"
        >
          删除
        </el-link> -->
      </template>
    </TableList>

    <!-- 新建子账号 -->
    <Dialog
      title="添加子账号"
      v-model="dialogVisible"
      @handleClose="$refs['addForm'].resetFields()"
    >
      <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="100px">
        <el-form-item label="银行名称" prop="user_name">
          <el-input v-model="addForm.user_name" placeholder="请输入银行名称">
            <el-tooltip slot="suffix">
              <span slot="content">格式：XXX银行XXX支行</span>
              <i class="el-icon-question"> </i>
            </el-tooltip>
          </el-input>
        </el-form-item>

        <el-form-item label="客户经理" prop="principal_name">
          <el-input v-model="addForm.principal_name" placeholder="请输入客户经理"></el-input>
        </el-form-item>

        <el-form-item label="联系方式" prop="mobile">
          <el-input v-model="addForm.mobile" placeholder="请输入联系方式"></el-input>
        </el-form-item>

        <el-form-item prop="location" label="所属地区">
          <ChinaArea v-model="addForm.location" />
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input v-model="addForm.password" show-password placeholder="请输入密码"></el-input>
        </el-form-item>

        <el-form-item label="状态" required>
          <el-radio-group v-model="addForm.lock">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label-width="0" class="text-center">
          <el-button type="primary" :loading="addLoading" @click="submitForm('addForm')">
            {{ isEdit ? "保存" : "添加" }}
          </el-button>
        </el-form-item>
      </el-form>
    </Dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as childAccountApi from "@/api/childAccount.js";
import TableList from "@/components/TableList";
import Dialog from "@/components/Dialog";
import ChinaArea from "@/components/ChinaArea";

const defaultForm = {
  user_name: "", //银行名称
  principal_name: "", // 客户经理名称
  mobile: "", //联系方式
  location: "", //所属地区
  password: "", //密码
  lock: 1 // 状态
};

export default {
  name: "ChildAccount",
  components: {
    TableList,
    Dialog,
    ChinaArea
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      const patter = new RegExp(/^1[3456789]\d{9}$/);
      if (value && !patter.test(value)) {
        return callback(new Error("手机号格式错误"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    };
    const validateBankName = (rule, value, callback) => {
      const patter = new RegExp(/^[\u4e00-\u9fa5]+银行+[\u4e00-\u9fa5]+支行$/);
      if (!value) {
        return callback(new Error("请输入银行名称"));
      } else if (!patter.test(value)) {
        return callback(new Error("银行名称格式填写错误"));
      } else {
        callback(); // 必须有此项回调，否则验证会一直不通过
      }
    };
    return {
      tableData: [],
      tableLabel: [
        { label: "银行名称", value: "user_name" },
        { label: "客户经理", value: "principal_name" },
        { label: "联系方式", value: "mobile" },
        { label: "所属地区", value: "location" },
        { label: "状态", value: "lock_text" },
        { label: "创建时间", value: "created_at" },
        { label: "操作", value: "active", isSlot: true }
      ],
      currentPage: 1,
      pageTotal: null,
      loading: true,

      addForm: Object.assign({}, defaultForm),
      addRules: {
        user_name: [{ required: true, validator: validateBankName, trigger: "blur" }],
        principal_name: [{ required: true, message: "请输入客户经理名称", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" }
        ],
        location: [{ required: true, message: "请选择所属地区", trigger: "change" }],
        password: [{ required: true, message: "请输入登录密码", trigger: "blur" }]
      },

      // 选中的项目
      activeRow: {},
      isEdit: false,

      dialogVisible: false,
      addLoading: false
    };
  },
  computed: {
    ...mapGetters(["user_info"])
  },

  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        this.isEdit && this.$set(this.addRules.password[0], "required", false);
      }
    }
  },

  mounted() {
    this.getChildAccount();
  },

  methods: {
    // 获取子账号列表
    async getChildAccount(page = 1) {
      this.loading = true;
      try {
        const { data } = await childAccountApi.getChildAccount({ page });

        this.tableData = data.data.map(v => {
          v["lock_text"] = v.lock === 1 ? "正常" : "禁用";
          return v;
        });
        this.currentPage = page;
        this.pageTotal = data.total;
      } catch (error) {}
      this.loading = false;
    },

    // 添加/编辑子账号
    async submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.addLoading = true;
          try {
            if (this.isEdit) {
              await childAccountApi.editChildAccount(this.addForm);
              this.getChildAccount(this.page);
            } else {
              await childAccountApi.addChildAccount(this.addForm);
              this.getChildAccount();
            }
            this.dialogVisible = false;
            this.$refs[formName].resetFields();
          } catch {}
          this.addLoading = false;
        } else {
          return false;
        }
      });
    },

    addAccount() {
      if (this.pageTotal >= this.user_info.sublevel_num) {
        return this.$message.error("子账号数量已达上限");
      }
      this.isEdit = false;
      this.dialogVisible = true;
    },

    // 编辑子账号
    editRow(rows) {
      /*
      在elemenui的el-dialog组件内，el-form的resetFields方法失效;
      原因：resetFields只会重置到弹窗打开时的表单值，而非初始data值
      解决方法：通过nextTick方法，在弹窗Dom完成后，将值赋值给el-form
      */
      this.isEdit = true;
      this.dialogVisible = true;

      this.$nextTick(() => {
        this.addForm = rows;
      });
    },

    // 删除子账号
    // deleteRow(id, rows) {
    //   const ind = rows.findIndex(i => i.id === id);
    //   this.$confirm("是否确定删除该账号，删除后不可恢复！", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //     lockScroll: false
    //   })
    //     .then(async () => {
    //       try {
    //         rows.splice(ind, 1);
    //         this.$message.success("删除成功!");
    //       } catch (error) {
    //         return false;
    //       }
    //     })
    //     .catch(() => {});
    // },

    // 分页
    async handleCurrentChange(page) {
      this.getChildAccount(page);
    }
  }
};
</script>

<style scoped lang="less"></style>
